export const handleString = (str: string): string => {
    const searchTerm: string = '_';
    const roleIndex: number = str.lastIndexOf(searchTerm);

    return str.slice(0, roleIndex);
}
